import {useRef, useState} from 'react';

import {Dialog} from 'primereact/dialog';
import {Button} from 'primereact/button';

import {ToastService} from '../../AppToast';
import { AppStorage } from '../../service/UserStorage';

interface ImZipProps {

  importZip(data: any): Promise<any>;

  reloadLazyData(result?: any): void;
}

export const useImZip = (props: ImZipProps) => {

  const {importZip, reloadLazyData} = props;

  const input = useRef(null);

  const [display, setDisplay] = useState(false);
  const [file, setFile] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  

  const showImportDialogZip = () => {
    setFile(null);
    setDisplay(true);
  }
  const onUploadZipFile = (event) => {
    if (event && event.target && event.target.files && event.target.files.length) {
      setFile(event.target.files[0]);
    }
  }

  const handleSubmit = () => {
    if (file) {
      if (!submitting) {
        setSubmitting(true);
        let tenantInfoString = AppStorage.get('tenantInfo');
        let tenantIncache = JSON.parse(tenantInfoString) || {};

        const formData = new FormData();
        formData.append('template', file);  
        formData.append('taxCode', tenantIncache.taxCode);
        importZip(formData).then(result => {
          setDisplay(false);
          ToastService.success();
          reloadLazyData(result);
        }).finally(() => {
          setSubmitting(false);
          input.current.value = '';
        });
      }
    } else {
      ToastService.error('Bạn chưa chọn file.');
    }
  }

  const renderImZip = () => {
    return (
      <Dialog header="Nhập mẫu tem" visible={display} style={{width: '40rem'}} position="top" onHide={() => setDisplay(false)}>
        <div className="p-fluid formgrid grid">
          <div className="field col-12 md:col-12">
            <label htmlFor="file">Chọn file</label>
            <input ref={input} id="file" type="file" accept=".zip" onChange={onUploadZipFile}/>
          </div>
        </div>

        <div className="flex justify-content-end">
          <Button label="Nhận file" icon="pi pi-upload" onClick={handleSubmit} loading={submitting} className="p-button-sm mr-2"/>
          <Button label="Đóng" icon="pi pi-times" onClick={() => setDisplay(false)} className="p-button-sm p-button-raised p-button-text p-button-plain"/>
        </div>
      </Dialog>
    );
  }
  return {renderImZip, showImportDialogZip};
}
